<template>
    <TileItem :item="tileItem">
        <template #buttons>
            <Permissions :permissions="['CRM.MANAGE']">
                <LTooltip
                    :label="$t(`admin.crm.table.editCrm`)"
                    position="is-bottom"
                    type="is-warning">
                    <b-button
                        icon-left="pen"
                        size="is-small"
                        type="is-warning is-light"
                        @click.prevent.stop="edit">
                    </b-button>
                </LTooltip>
            </Permissions>
    
            <Permissions :permissions="['CRM.MANAGE']">
                <LTooltip
                    :label="$t(`admin.crm.table.removeCrm`)"
                    position="is-bottom"
                    type="is-danger">
                    <b-button
                        :loading="isLoading"
                        icon-left="trash-alt"
                        icon-pack="far"
                        size="is-small"
                        type="is-danger is-light"
                        @click.prevent.stop="remove">
                    </b-button>
                </LTooltip>
            </Permissions>
        </template>
    </TileItem>
</template>

<script>
  import Permissions from "@/components/Common/Permissions.vue";
  import TileItem from "@/components/Common/TileItem";
  
  export default {
    name: "CRMTableItem",
    components: {
      TileItem,
      Permissions
    },

    props: {
      item: {
        type: Object,
        required: true
      },
      isLoading: {
        type: Boolean,
        default: null
      }
    },

    computed: {
      tileItem () {
        return {
          ...this.item,
          title: this.item.name
        };
      }
    },

    methods: {
      open () {
        this.$emit("open");
      },
      
      edit () {
        this.$emit("edit", this.item.alias);
      },

      remove () {
        this.$emit("delete", this.item.alias);
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>
